import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './assets/css/style.css';
import './assets/css/nice-select.css';
import './assets/css/swiper-bundle.min.css';
import './assets/css/jquery.fancybox.min.css';
import './assets/css/animate.css';
import './assets/css/boxicons.min.css';
import './assets/css/bootstrap-icons.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/boxicons.min.css';
import '../emagazine/assets/css/new_style.css'
import BybFooter from '../../Components/BybMainPage/BybFooter/BybFooter.jsx';
import PageSeo from '../../Components/Common/Seo/PageSeo.jsx';
import { DEFAULT_OG_IMAGE, HOMEPAGE_META_DESCRIPTION, SITE_LOGO, SITE_NAME, SITE_URL, stripHtml, toCanonicalUrl, toTitleCase } from '../../Components/Common/Seo/seoUtils.js';
import { demoteArticleBodyH1Tags } from './articleHeadingUtils.js';
import { copyTextToClipboard } from './clipboardUtils.js';
import { AUTHOR_JOB_TITLE, buildAuthorPath, getArticleAuthorName, getAuthorProfileByName } from './authorData.js';
import {
    buildEmagazineApiUrl,
    buildEmagazineArticlePath,
    buildEmagazineCategoryPath,
    buildEmagazineUploadUrl,
    resolveEmagazineCategoryParam,
} from './emagazineApi.js';
import { EBOOK_CTA_TITLE, EBOOK_CTA_URL, getEbookCtaTrackingAttributes, trackEbookCtaClick } from './ebookCtaTracking.js';

const getFirstPopulatedField = (source, fieldNames) => {
    if (!source) return "";

    for (const fieldName of fieldNames) {
        const value = source[fieldName];

        if (value !== undefined && value !== null && String(value).trim()) {
            return String(value).trim();
        }
    }

    return "";
};

const getArticleExcerpt = (article) => stripHtml(getFirstPopulatedField(article, [
    "excerpt",
    "summary",
    "short_description",
    "shortDescription",
    "description",
    "meta_description",
    "og_description",
    "content",
]));

const getArticleCoverImage = (article) => getFirstPopulatedField(article, [
    "cover_image",
    "coverImage",
    "cover",
    "banner",
    "image",
    "image2",
    "image3",
    "thumbnail",
]);

const resolveArticleImageUrl = (image) => {
    if (!image) return "";
    if (/^https?:\/\//i.test(image)) return image;

    return buildEmagazineUploadUrl(image);
};

const getArticleDateField = (article, fieldNames) => {
    const value = getFirstPopulatedField(article, fieldNames);
    if (!value) return "";

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? "" : parsedDate.toISOString();
};
const resolveSeoImageUrl = (image) => {
    if (!image) return "";
    if (/^https?:\/\//i.test(image)) return image;

    return buildEmagazineUploadUrl(image);
};

const isHomepageDescription = (description) => (
    stripHtml(description || "").toLowerCase() === HOMEPAGE_META_DESCRIPTION.toLowerCase()
);

const isGenericArticleTitle = (title) => {
    const normalizedTitle = stripHtml(title || "").toLowerCase();

    return !normalizedTitle
        || normalizedTitle === "brew your brand | branding tools & creative community"
        || normalizedTitle === "brand-building resources, community, emagazine & assessment tools | brew your brand";
};


const BlogDetailPage = () =>
{
    const navigate = useNavigate();
        const { categoryId, blogId } = useParams();
        const [showHamburgerMenu, setshowHamburgerMenu] = useState(false)
    const handleHamburgerMenu = ()=>{
        setshowHamburgerMenu((preState)=>!preState)
        console.log('clicked');
    }

        const location = useLocation();
        const getCategoryHref = (name) => buildEmagazineCategoryPath(name);

        const lastSegment = decodeURIComponent(blogId || "");
        const secondLastSegment = resolveEmagazineCategoryParam(categoryId || "");

        const [posts, setPosts] = useState([]);
        const [isFeaturedLoading, setIsFeaturedLoading] = useState(true);
        const [featuredError, setFeaturedError] = useState(null);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(null);

        useEffect(() => {
            if (!categoryId || !lastSegment || !secondLastSegment) return;

            const cleanArticlePath = buildEmagazineArticlePath(secondLastSegment, lastSegment);

            if (location.pathname !== cleanArticlePath) {
                navigate(cleanArticlePath, { replace: true });
            }
        }, [categoryId, lastSegment, secondLastSegment, location.pathname, navigate]);

        useEffect(() => {
            const fetchPostsByCategory = async () => {
                setIsFeaturedLoading(true);
                setFeaturedError(null);

                if (!secondLastSegment) {
                    setPosts([]);
                    setIsFeaturedLoading(false);
                    return;
                }

                try {
                    const response = await fetch(
                        buildEmagazineApiUrl(
                            `get_featured_blogs_by_category.php?category=${encodeURIComponent(secondLastSegment)}`
                        )
                    );

                    if (!response.ok) throw new Error('Failed to fetch posts');

                    const data = await response.json();

                    if (!data.success) {
                        throw new Error(data.message || "Failed to load posts due to API error.");
                    }

                    setPosts(data.success ? data.blogs : []);
                    setFeaturedError(null);
                } catch (error) {
                    console.error("Error fetching posts:", error);
                    setFeaturedError('Failed to load posts');
                } finally {
                    setIsFeaturedLoading(false);
                }
            };

            fetchPostsByCategory();
        }, [secondLastSegment]);

        const [categories, setCategories] = useState([]);

        const [blogData, setBlogData] = useState(null);
        const [isBlogLoading, setIsBlogLoading] = useState(true);
        const [blogError, setBlogError] = useState(null);
        const [seoData, setSeoData] = useState(null);

        useEffect(() => {
            const fetchCategories = async () => {
                try {
                    const response = await fetch(buildEmagazineApiUrl("get_categories.php"));
                    const data = await response.json();

                    if (data.success) {
                        setCategories(data.categories);
                    } else {
                        console.error("Failed to fetch categories");
                    }
                } catch (error) {
                    console.error("Error fetching categories:", error);
                }
            };

            fetchCategories();
        }, []);

        useEffect(() => {
            const fetchBlogData = async () => {
                setIsBlogLoading(true);
                setBlogError(null);

                if (!lastSegment) {
                    setBlogData(null);
                    setBlogError("Blog not found.");
                    setIsBlogLoading(false);
                    return;
                }

                try {
                    const response = await fetch(
                        buildEmagazineApiUrl(`get_blogs_by_slug.php?slug=${encodeURIComponent(lastSegment)}`)
                    );

                    if (!response.ok) {
                        throw new Error("Failed to fetch blog data.");
                    }

                    const data = await response.json();
                    const blog = Array.isArray(data.blogs) ? data.blogs[0] : null;

                    if (!data.success || !blog) {
                        setBlogData(null);
                        setBlogError(data.message || "Blog not found.");
                    } else if (blog.approved === "1" || blog.approved === 1) {
                        setBlogData(blog);
                        setBlogError(null);
                    } else {
                        navigate("/404");
                    }
                } catch (err) {
                    setBlogData(null);
                    setBlogError("Failed to fetch blog data.");
                } finally {
                    setIsBlogLoading(false);
                }
            };

            fetchBlogData();
        }, [lastSegment, navigate]);

        useEffect(() => {
            let isMounted = true;

            const fetchSeoData = async () => {
                try {
                    const response = await fetch(
                        buildEmagazineApiUrl(`get_meta_tag_slug.php?slug=${encodeURIComponent(lastSegment)}`)
                    );

                    if (!response.ok) {
                        throw new Error("Failed to fetch SEO metadata.");
                    }

                    const data = await response.json();

                    if (isMounted && data.success) {
                        setSeoData(data.metaTags);
                    }
                } catch (fetchError) {
                    console.error("Error fetching blog SEO metadata:", fetchError);
                }
            };

            fetchSeoData();

            return () => {
                isMounted = false;
            };
        }, [lastSegment]);

        const currentUrl = window.location.href;
        const [isLinkCopied, setIsLinkCopied] = useState(false);

        const handleCopyLink = async () => {
            try {
                await copyTextToClipboard(currentUrl);
                setIsLinkCopied(true);
                window.setTimeout(() => setIsLinkCopied(false), 2000);
            } catch (error) {
                console.error('Unable to copy article link:', error);
            }
        };

        const [email, setEmail] = useState("");
        const [message, setMessage] = useState("");
        const [messageType, setMessageType] = useState("");

        const validateEmail = (email) => {
            return /\S+@\S+\.\S+/.test(email);
        };

        const handleSubscribe = async () => {
            if (!validateEmail(email)) {
                setMessage("❌ Please enter a valid email address.");
                setMessageType("error");
                return;
            }

            const formData = { email };

            try {
                const response = await fetch(
                    buildEmagazineApiUrl("subscriber-submit.php"),
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(formData),
                    }
                );

                const data = await response.json();

                if (data.success) {
                    setMessage("✅ Thank you for subscribing!");
                    setMessageType("success");
                    setEmail(""); // Clear input after successful subscription
                } else {
                    setMessage("❌ Subscription failed. Please try again.");
                    setMessageType("error");
                }
            } catch (error) {
                setMessage("❌ An error occurred. Please try again later.");
                setMessageType("error");
            }
        };

        const [randomPosts, setRandomPosts] = useState([]);

        useEffect(() => {
            const fetchRandomPosts = async () => {
                setIsLoading(true);
                setError(null);

                try {
                    const response = await fetch(buildEmagazineApiUrl("random-posts.php"));

                    if (!response.ok) throw new Error("Failed to fetch random posts");

                    const data = await response.json();

                    if (!data.success) {
                        throw new Error(data.message || "Failed to load posts due to API error.");
                    }

                    if (data.success && Array.isArray(data.blogs)) {
                        // ✅ Shuffle posts and pick two random ones
                        const shuffled = data.blogs.sort(() => 0.5 - Math.random());
                        const randomTwo = shuffled.slice(0, 2);
                        setRandomPosts(randomTwo);
                    } else {
                        setRandomPosts([]);
                    }

                    const availablePosts = Array.isArray(data.data)
                        ? data.data
                        : Array.isArray(data.blogs)
                            ? data.blogs
                            : [];

                    if (availablePosts.length > 0) {
                        const filteredPosts = availablePosts.filter((post) => post.slug && post.slug !== lastSegment);
                        const shuffledPosts = [...filteredPosts].sort(() => 0.5 - Math.random());
                        setRandomPosts(shuffledPosts.slice(0, 2));
                    } else {
                        setRandomPosts([]);
                        setError("No posts available.");
                    }
                } catch (error) {
                    console.error("Error fetching random posts:", error);
                    setError("Failed to load posts.");
                } finally {
                    setIsLoading(false);
                }
            };

            fetchRandomPosts();
        }, [lastSegment]);



        const articleTitle = blogData?.title ? `${blogData.title} | Brew Your Brand eMagazine` : "";
        const routeArticleTitle = lastSegment
          ? `${toTitleCase(lastSegment)} | Brew Your Brand eMagazine`
          : "";
        const seoTitle = isGenericArticleTitle(seoData?.title) ? "" : seoData?.title;
        const seoOgTitle = isGenericArticleTitle(seoData?.og_title) ? "" : seoData?.og_title;
        const articleExcerpt = getArticleExcerpt(blogData);
        const articleCoverImage = resolveArticleImageUrl(getArticleCoverImage(blogData));
        const seoDescription = isHomepageDescription(seoData?.description) ? "" : seoData?.description;
        const seoOgDescription = isHomepageDescription(seoData?.og_description) ? "" : seoData?.og_description;
        const articleDescriptionFallback = blogData?.title
          ? `Read ${blogData.title} on Brew Your Brand eMagazine for practical brand-building insights and ideas.`
          : "Read the latest brand-building insights, ideas, and practical guidance from Brew Your Brand eMagazine.";
        const blogTitle = articleTitle || seoTitle || routeArticleTitle || "Brew Your Brand eMagazine";
        const blogDescription = articleExcerpt
          || seoDescription
          || articleDescriptionFallback;
        const blogCanonical = buildEmagazineArticlePath(blogData?.category || secondLastSegment, blogData?.slug || lastSegment);
        const articleAuthorName = getArticleAuthorName(blogData);
        const articleAuthorProfile = getAuthorProfileByName(articleAuthorName);
        const articleAuthorPath = articleAuthorProfile ? buildAuthorPath(articleAuthorProfile) : "";
        const articleAuthorUrl = articleAuthorPath ? toCanonicalUrl(articleAuthorPath) : "";
        const blogOgTitle = articleTitle || seoOgTitle || blogTitle;
        const blogOgDescription = articleExcerpt || seoOgDescription || blogDescription;
        const blogOgImage = articleCoverImage || resolveSeoImageUrl(seoData?.og_image) || DEFAULT_OG_IMAGE;
        const articlePublishedTime = getArticleDateField(blogData, [
          "published_at",
          "publishedAt",
          "published_date",
          "publish_date",
          "created_at",
          "createdAt",
          "date",
        ]);
        const articleModifiedTime = getArticleDateField(blogData, [
          "updated_at",
          "updatedAt",
          "modified_at",
          "modifiedAt",
          "date_modified",
          "created_at",
          "createdAt",
          "date",
        ]);
        const blogArticleSchema = blogData?.title ? {
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "@id": `${toCanonicalUrl(blogCanonical)}#article`,
          headline: blogData.title,
          description: stripHtml(blogOgDescription).slice(0, 300),
          image: [blogOgImage],
          datePublished: articlePublishedTime || undefined,
          dateModified: articleModifiedTime || articlePublishedTime || undefined,
          author: articleAuthorProfile ? {
            "@type": "Person",
            "@id": `${articleAuthorUrl}#person`,
            name: articleAuthorProfile.name,
            jobTitle: AUTHOR_JOB_TITLE,
            url: articleAuthorUrl,
          } : {
            "@type": "Person",
            name: articleAuthorName || SITE_NAME,
          },
          publisher: {
            "@type": "Organization",
            "@id": `${SITE_URL}/#organization`,
            name: SITE_NAME,
            logo: {
              "@type": "ImageObject",
              url: SITE_LOGO,
            },
          },
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id": toCanonicalUrl(blogCanonical),
          },
          articleSection: blogData.category || secondLastSegment || "eMagazine",
        } : null;
        const blogBreadcrumbCategory = blogData?.category || secondLastSegment;
        const blogBreadcrumbTitle = blogData?.title || routeArticleTitle || "";
        const blogBreadcrumbItems = [
          {
            "@type": "ListItem",
            name: "Home",
            item: toCanonicalUrl("/"),
          },
          {
            "@type": "ListItem",
            name: "BYB eMagazine",
            item: toCanonicalUrl("/e-magazine/"),
          },
          blogBreadcrumbCategory ? {
            "@type": "ListItem",
            name: toTitleCase(blogBreadcrumbCategory),
            item: toCanonicalUrl(buildEmagazineCategoryPath(blogBreadcrumbCategory)),
          } : null,
          blogBreadcrumbTitle ? {
            "@type": "ListItem",
            name: stripHtml(blogBreadcrumbTitle).replace(/\s*\|\s*Brew Your Brand eMagazine$/i, ""),
            item: toCanonicalUrl(blogCanonical),
          } : null,
        ].filter(Boolean).map((item, index) => ({
          ...item,
          position: index + 1,
        }));
        const blogBreadcrumbSchema = blogBreadcrumbItems.length > 1 ? {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "@id": `${toCanonicalUrl(blogCanonical)}#breadcrumb`,
          itemListElement: blogBreadcrumbItems,
        } : null;
        const blogStructuredData = [blogArticleSchema, blogBreadcrumbSchema].filter(Boolean);
        const normalizedBlogContent = blogData?.content
          ? demoteArticleBodyH1Tags(blogData.content)
          : "";
        const relatedArticleMap = new Map();

        [...posts, ...randomPosts].forEach((post) => {
            if (!post?.slug || !post?.category || !post?.title || post.slug === lastSegment) return;

            const articlePath = buildEmagazineArticlePath(post.category, post.slug);

            if (!relatedArticleMap.has(articlePath)) {
                relatedArticleMap.set(articlePath, {
                    ...post,
                    articlePath,
                    categoryPath: buildEmagazineCategoryPath(post.category),
                    excerpt: getArticleExcerpt(post),
                    imageUrl: resolveArticleImageUrl(getArticleCoverImage(post)),
                });
            }
        });

        const relatedArticles = Array.from(relatedArticleMap.values()).slice(0, 3);
    return (
        <>
 <PageSeo
    title={blogTitle}
    description={blogDescription}
    canonical={blogCanonical}
    ogTitle={blogOgTitle}
    ogDescription={blogOgDescription}
    ogImage={blogOgImage}
    ogType="article"
    robots={seoData?.robots || "index,follow"}
    structuredData={blogStructuredData}
    articlePublishedTime={articlePublishedTime}
    articleModifiedTime={articleModifiedTime || articlePublishedTime}
 />
 <div className="emagazine-detail-page" >



    <div className={`${showHamburgerMenu ? "show-menu" : ""} sidebar-menu d-lg-none d-sm-block`}>
    <div className="mobile-logo-area d-flex justify-content-between align-items-center">
                <div className="header-logo ">
                    <a href="/e-magazine/"><img alt="Brew Your Brand eMagazine logo" className="img-fluid dark" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg" /></a>
                    <a href="/e-magazine/"><img alt="Brew Your Brand eMagazine logo" className="img-fluid light" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg" /></a>
                </div>
                <div className="menu-button menu-close-btn" onClick={handleHamburgerMenu}>
                    <i className="bi bi-x"></i>
                </div>
            </div>

            <ul className="menu-list">
                    {categories.map(category => (
                            <li key={category.id}>
                                <a href={getCategoryHref(category.name)}>{category.name} </a>
                            </li>
                    ))}
            </ul>

            <div className="menu-bottom-content">

 <div class="header-right">
                <a href="javascript:void(0)"  class="submit_quote" id="visual-projects">Submit Your Article</a>
                <li class=" " id="popup-container">
                    <div data-tf-live="01JSY0YC8JZVDTTCVBWM28RKPN" class="article_form"></div>
                 </li>
            </div>

            <div class="social-wrap">
                <h6>Follow Social Media </h6>
                <ul class="social-area">
                    <li>
                        <a href="https://www.facebook.com/BrewYourBrandOfficial">
                            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7.81526 12.2483V7.46726H9.42818L9.66793 5.59534H7.81526V4.40301C7.81526 3.86284 7.96576 3.49301 8.74101 3.49301H9.72334V1.82409C9.24538 1.77287 8.76495 1.74814 8.28426 1.75001C6.85859 1.75001 5.87976 2.62034 5.87976 4.21809V5.59184H4.27734V7.46376H5.88326V12.2483H7.81526Z">
                                </path>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://x.com/brew_your_brand">
                            <svg width="12" height="12" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path
                                        d="M11.025 0.65625H13.1722L8.48225 6.0305L14 13.3438H9.68012L6.2965 8.9075L2.42462 13.3438H0.2765L5.29287 7.595L0 0.65625H4.43013L7.48825 4.71012L11.025 0.65625ZM10.2725 12.0557H11.4625L3.78262 1.87687H2.50688L10.2725 12.0557Z">
                                    </path>
                                </g>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/brew-your-brand">
                            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2.90719 4.1972C3.61209 4.1972 4.18353 3.62576 4.18353 2.92086C4.18353 2.21597 3.61209 1.64453 2.90719 1.64453C2.20229 1.64453 1.63086 2.21597 1.63086 2.92086C1.63086 3.62576 2.20229 4.1972 2.90719 4.1972Z">
                                </path>
                                <path
                                    d="M5.38752 5.16523V12.2463H7.5861V8.74457C7.5861 7.82057 7.75994 6.92573 8.9056 6.92573C10.0355 6.92573 10.0495 7.98215 10.0495 8.8029V12.2469H12.2493V8.36365C12.2493 6.45615 11.8386 4.99023 9.60911 4.99023C8.53869 4.99023 7.82119 5.57765 7.52777 6.13357H7.49802V5.16523H5.38752ZM1.80469 5.16523H4.00677V12.2463H1.80469V5.16523Z">
                                </path>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/brew_your_brand">
                            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12.2191 4.84492C12.2132 4.40312 12.1305 3.96571 11.9747 3.55226C11.8396 3.20351 11.6332 2.88679 11.3687 2.62233C11.1043 2.35786 10.7875 2.15147 10.4388 2.01634C10.0307 1.86313 9.59948 1.78029 9.16362 1.77134C8.60246 1.74626 8.42454 1.73926 7.00004 1.73926C5.57554 1.73926 5.39296 1.73926 4.83587 1.77134C4.40022 1.78036 3.96924 1.8632 3.56129 2.01634C3.21249 2.15138 2.89572 2.35773 2.63124 2.62221C2.36677 2.88669 2.16041 3.20346 2.02537 3.55226C1.87186 3.96008 1.7892 4.39116 1.78096 4.82684C1.75587 5.38859 1.74829 5.56651 1.74829 6.99101C1.74829 8.41551 1.74829 8.59751 1.78096 9.15517C1.78971 9.59151 1.87196 10.022 2.02537 10.4309C2.16064 10.7796 2.36715 11.0963 2.63171 11.3606C2.89628 11.625 3.21308 11.8313 3.56187 11.9663C3.96871 12.1256 4.39976 12.2144 4.83646 12.2288C5.39821 12.2538 5.57612 12.2614 7.00062 12.2614C8.42512 12.2614 8.60771 12.2614 9.16479 12.2288C9.60063 12.2202 10.0318 12.1375 10.44 11.9843C10.7886 11.8491 11.1053 11.6426 11.3697 11.3782C11.6341 11.1137 11.8406 10.7971 11.9759 10.4484C12.1293 10.0401 12.2115 9.60959 12.2203 9.17267C12.2454 8.61151 12.253 8.43359 12.253 7.00851C12.2518 5.58401 12.2518 5.40317 12.2191 4.84492ZM6.99654 9.68484C5.50671 9.68484 4.29979 8.47792 4.29979 6.98809C4.29979 5.49826 5.50671 4.29134 6.99654 4.29134C7.71176 4.29134 8.39769 4.57546 8.90343 5.0812C9.40917 5.58694 9.69329 6.27287 9.69329 6.98809C9.69329 7.70331 9.40917 8.38924 8.90343 8.89498C8.39769 9.40072 7.71176 9.68484 6.99654 9.68484ZM9.80062 4.82042C9.71802 4.8205 9.63622 4.80429 9.55989 4.77271C9.48356 4.74114 9.41421 4.69482 9.3558 4.63641C9.29739 4.57801 9.25108 4.50865 9.2195 4.43233C9.18793 4.356 9.17171 4.27419 9.17179 4.19159C9.17179 4.10905 9.18805 4.02732 9.21964 3.95106C9.25122 3.8748 9.29752 3.80551 9.35589 3.74714C9.41425 3.68878 9.48354 3.64248 9.5598 3.61089C9.63606 3.57931 9.71779 3.56305 9.80033 3.56305C9.88287 3.56305 9.96461 3.57931 10.0409 3.61089C10.1171 3.64248 10.1864 3.68878 10.2448 3.74714C10.3031 3.80551 10.3494 3.8748 10.381 3.95106C10.4126 4.02732 10.4289 4.10905 10.4289 4.19159C10.4289 4.53926 10.1477 4.82042 9.80062 4.82042Z">
                                </path>
                                <path
                                    d="M6.99589 8.73983C7.96336 8.73983 8.74764 7.95554 8.74764 6.98808C8.74764 6.02061 7.96336 5.23633 6.99589 5.23633C6.02843 5.23633 5.24414 6.02061 5.24414 6.98808C5.24414 7.95554 6.02843 8.73983 6.99589 8.73983Z">
                                </path>
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
            </div>
    </div>

    <div className="header-area2">
        <div className="container d-flex d-lg-flex align-items-center justify-content-between">

            <div className="header-logo d-flex blog_dd">
                <a href="https://brewyourbrand.in/"><img alt="Brew Your Brand logo" className="img-fluid dark" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"/></a>

                <p>eMagazine</p>
                {/* <a href="https://brewyourbrand.in/"><img alt="image" className="img-fluid light" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"/></a> */}
            </div>

            <div className="header-menu-icon d-lg-none d-sm-block d-md-none">
                <div className="menu-icon" onClick={handleHamburgerMenu}>
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M1.66675 9.16666H18.3334V10.8333H1.66675V9.16666ZM1.66675 4.16666H18.3334V5.83332H1.66675V4.16666ZM1.66675 14.1667H18.3334V15.8333H1.66675V14.1667Z" />
                    </svg>
                </div>
                <div className="tt-style-switch">
                    <i className="bi bi-brightness-low-fill"></i>
                </div>
            </div>

            <div className="header-right detail-header-ctas d-md-flex d-none">
                <div className="search-bar">
                    {/* <div className="search-btn">
                        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M7.67458 2.95934C5.06925 2.95934 2.95925 5.06868 2.95925 7.66868C2.95925 10.2687 5.06925 12.3773 7.67458 12.3773C8.97459 12.3773 10.1499 11.8533 11.0033 11.004C11.4434 10.5674 11.7926 10.0477 12.0307 9.47524C12.2687 8.90273 12.3908 8.28869 12.3899 7.66868C12.3899 5.06868 10.2799 2.95934 7.67458 2.95934ZM1.33325 7.66868C1.33325 4.16868 4.17325 1.33334 7.67458 1.33334C11.1759 1.33334 14.0159 4.16868 14.0159 7.66868C14.0178 9.07185 13.5516 10.4356 12.6913 11.544L14.4279 13.2787C14.5084 13.353 14.573 13.4427 14.618 13.5426C14.6629 13.6424 14.6872 13.7503 14.6894 13.8598C14.6916 13.9693 14.6717 14.0781 14.6309 14.1797C14.59 14.2813 14.5291 14.3736 14.4517 14.4511C14.3743 14.5286 14.2821 14.5896 14.1805 14.6306C14.079 14.6716 13.9702 14.6916 13.8607 14.6895C13.7512 14.6874 13.6433 14.6632 13.5434 14.6184C13.4435 14.5736 13.3536 14.5091 13.2793 14.4287L11.5393 12.6913C10.4316 13.544 9.07244 14.0054 7.67458 14.0033C4.17325 14.0033 1.33325 11.168 1.33325 7.66868Z" />
                        </svg>
                    </div> */}
                    {/* <div className="search-input">
                        <div className="serch-close"></div>
                        <form>
                            <div className="search-group">
                                <div className="form-inner2">
                                    <input type="text" placeholder="Enter your keywords"/>
                                    <button type="submit">
                                        <svg width="16" height="16" viewBox="0 0 16 16"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M7.67458 2.95934C5.06925 2.95934 2.95925 5.06868 2.95925 7.66868C2.95925 10.2687 5.06925 12.3773 7.67458 12.3773C8.97459 12.3773 10.1499 11.8533 11.0033 11.004C11.4434 10.5674 11.7926 10.0477 12.0307 9.47524C12.2687 8.90273 12.3908 8.28869 12.3899 7.66868C12.3899 5.06868 10.2799 2.95934 7.67458 2.95934ZM1.33325 7.66868C1.33325 4.16868 4.17325 1.33334 7.67458 1.33334C11.1759 1.33334 14.0159 4.16868 14.0159 7.66868C14.0178 9.07185 13.5516 10.4356 12.6913 11.544L14.4279 13.2787C14.5084 13.353 14.573 13.4427 14.618 13.5426C14.6629 13.6424 14.6872 13.7503 14.6894 13.8598C14.6916 13.9693 14.6717 14.0781 14.6309 14.1797C14.59 14.2813 14.5291 14.3736 14.4517 14.4511C14.3743 14.5286 14.2821 14.5896 14.1805 14.6306C14.079 14.6716 13.9702 14.6916 13.8607 14.6895C13.7512 14.6874 13.6433 14.6632 13.5434 14.6184C13.4435 14.5736 13.3536 14.5091 13.2793 14.4287L11.5393 12.6913C10.4316 13.544 9.07244 14.0054 7.67458 14.0033C4.17325 14.0033 1.33325 11.168 1.33325 7.66868Z" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div className="quick-search">
                                <ul>
                                    <li>Quick Search :</li>
                                    <li><a href="life-style.html">Beauty,</a></li>
                                    <li><a href="life-style.html">Gaming Tips,</a></li>
                                    <li><a href="life-style.html">Fashion,</a></li>
                                    <li><a href="life-style.html">Tech,</a></li>
                                </ul>
                            </div>
                        </form>
                    </div> */}
                </div>
                <a href="javascript:void(0)" class="submit_quote" id="visual-projects">Submit Your Article</a>
                <li class=" " id="popup-container">
                    <div data-tf-live="01JSY0YC8JZVDTTCVBWM28RKPN" class="article_form"></div>
                </li>
                <div className="subscribe-btn ">
                    <a href="#" className="primary-btn hover-btn text-decoration-none">
                        {/* <svg className="arrow" width="11" height="11" viewBox="0 0 11 11"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.999756 10L9.99976 1M9.99976 1C7.99976 1.375 3.62476 2.125 0.999756 1M9.99976 1C9.62476 2.875 8.87476 7 9.99976 10"
                                stroke="#191919" stroke-width="1.5" stroke-linecap="round" />
                        </svg> */}
                        Subscribe
                    </a>

                </div>
            </div>
        </div>
    </div>

    <header className="life-style d-lg-flex d-lg-block d-none d-md-block">
        <div className="container-md">
            <div className="col-lg-12 px-0">
                <div className="header-wrapper">
                    <div className="main-menu">
                        <ul className="menu-list">
                            {/* <li className="menu-item-has-children active">
                                <ul className="sub-menu">
                                {categories.map(category => (
                                        <li key={category.id}>
                                            <a href={getCategoryHref(category.name)}>
                                                {category.name}
                                            </a>
                                        </li>
                                    ))}

                                </ul>
                            </li> */}
                            {categories.map(category => (
    <li key={category.id}>
        <a href={getCategoryHref(category.name)}>
            {category.name}
        </a>
    </li>
))}

                        </ul>
                    </div>
                    <div className="nav-right d-flex jsutify-content-end align-items-center">
                        <ul className="social-area">
                            <li>
                                <a href="https://www.facebook.com/BrewYourBrandOfficial">
                                    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.81526 12.2483V7.46726H9.42818L9.66793 5.59534H7.81526V4.40301C7.81526 3.86284 7.96576 3.49301 8.74101 3.49301H9.72334V1.82409C9.24538 1.77287 8.76495 1.74814 8.28426 1.75001C6.85859 1.75001 5.87976 2.62034 5.87976 4.21809V5.59184H4.27734V7.46376H5.88326V12.2483H7.81526Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://x.com/brew_your_brand">
                                    <svg width="12" height="12" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <g>
                                            <path
                                                d="M11.025 0.65625H13.1722L8.48225 6.0305L14 13.3438H9.68012L6.2965 8.9075L2.42462 13.3438H0.2765L5.29287 7.595L0 0.65625H4.43013L7.48825 4.71012L11.025 0.65625ZM10.2725 12.0557H11.4625L3.78262 1.87687H2.50688L10.2725 12.0557Z">
                                            </path>
                                        </g>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/company/brew-your-brand">
                                    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.90719 4.1972C3.61209 4.1972 4.18353 3.62576 4.18353 2.92086C4.18353 2.21597 3.61209 1.64453 2.90719 1.64453C2.20229 1.64453 1.63086 2.21597 1.63086 2.92086C1.63086 3.62576 2.20229 4.1972 2.90719 4.1972Z">
                                        </path>
                                        <path
                                            d="M5.38752 5.16523V12.2463H7.5861V8.74457C7.5861 7.82057 7.75994 6.92573 8.9056 6.92573C10.0355 6.92573 10.0495 7.98215 10.0495 8.8029V12.2469H12.2493V8.36365C12.2493 6.45615 11.8386 4.99023 9.60911 4.99023C8.53869 4.99023 7.82119 5.57765 7.52777 6.13357H7.49802V5.16523H5.38752ZM1.80469 5.16523H4.00677V12.2463H1.80469V5.16523Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/brew_your_brand">
                                    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12.2191 4.84492C12.2132 4.40312 12.1305 3.96571 11.9747 3.55226C11.8396 3.20351 11.6332 2.88679 11.3687 2.62233C11.1043 2.35786 10.7875 2.15147 10.4388 2.01634C10.0307 1.86313 9.59948 1.78029 9.16362 1.77134C8.60246 1.74626 8.42454 1.73926 7.00004 1.73926C5.57554 1.73926 5.39296 1.73926 4.83587 1.77134C4.40022 1.78036 3.96924 1.8632 3.56129 2.01634C3.21249 2.15138 2.89572 2.35773 2.63124 2.62221C2.36677 2.88669 2.16041 3.20346 2.02537 3.55226C1.87186 3.96008 1.7892 4.39116 1.78096 4.82684C1.75587 5.38859 1.74829 5.56651 1.74829 6.99101C1.74829 8.41551 1.74829 8.59751 1.78096 9.15517C1.78971 9.59151 1.87196 10.022 2.02537 10.4309C2.16064 10.7796 2.36715 11.0963 2.63171 11.3606C2.89628 11.625 3.21308 11.8313 3.56187 11.9663C3.96871 12.1256 4.39976 12.2144 4.83646 12.2288C5.39821 12.2538 5.57612 12.2614 7.00062 12.2614C8.42512 12.2614 8.60771 12.2614 9.16479 12.2288C9.60063 12.2202 10.0318 12.1375 10.44 11.9843C10.7886 11.8491 11.1053 11.6426 11.3697 11.3782C11.6341 11.1137 11.8406 10.7971 11.9759 10.4484C12.1293 10.0401 12.2115 9.60959 12.2203 9.17267C12.2454 8.61151 12.253 8.43359 12.253 7.00851C12.2518 5.58401 12.2518 5.40317 12.2191 4.84492ZM6.99654 9.68484C5.50671 9.68484 4.29979 8.47792 4.29979 6.98809C4.29979 5.49826 5.50671 4.29134 6.99654 4.29134C7.71176 4.29134 8.39769 4.57546 8.90343 5.0812C9.40917 5.58694 9.69329 6.27287 9.69329 6.98809C9.69329 7.70331 9.40917 8.38924 8.90343 8.89498C8.39769 9.40072 7.71176 9.68484 6.99654 9.68484ZM9.80062 4.82042C9.71802 4.8205 9.63622 4.80429 9.55989 4.77271C9.48356 4.74114 9.41421 4.69482 9.3558 4.63641C9.29739 4.57801 9.25108 4.50865 9.2195 4.43233C9.18793 4.356 9.17171 4.27419 9.17179 4.19159C9.17179 4.10905 9.18805 4.02732 9.21964 3.95106C9.25122 3.8748 9.29752 3.80551 9.35589 3.74714C9.41425 3.68878 9.48354 3.64248 9.5598 3.61089C9.63606 3.57931 9.71779 3.56305 9.80033 3.56305C9.88287 3.56305 9.96461 3.57931 10.0409 3.61089C10.1171 3.64248 10.1864 3.68878 10.2448 3.74714C10.3031 3.80551 10.3494 3.8748 10.381 3.95106C10.4126 4.02732 10.4289 4.10905 10.4289 4.19159C10.4289 4.53926 10.1477 4.82042 9.80062 4.82042Z">
                                        </path>
                                        <path
                                            d="M6.99589 8.73983C7.96336 8.73983 8.74764 7.95554 8.74764 6.98808C8.74764 6.02061 7.96336 5.23633 6.99589 5.23633C6.02843 5.23633 5.24414 6.02061 5.24414 6.98808C5.24414 7.95554 6.02843 8.73983 6.99589 8.73983Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>


    {/* <div className="inner-page-banner-section ">
    <div className="container">
        <div className="row">
            <div className="col-lg-12">
                <div
                    className="inner-page-banner-wrapper"
                    // style={{ backgroundimage: 'url(../../../src/pages/emagazine/assets/image/life-style/Background-7.png)' }}
                >
                    <div className="banner-content">
                        <h2>{blogData?.title}</h2>
                        <ul className="breadcrumb-list">
                            <li><a href="index.html" className='text-decoration-none'>Home</a></li>
                            {blogData?.title && <li>{blogData.title}</li>}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div> */}


    <div className="blog-post-9">

  {/* <header className="slid_txt" aria-label="Featured eBook">
    <p>eBook <span></span> {EBOOK_CTA_TITLE}
    <a
        href={EBOOK_CTA_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-white text-decoration-underline"
        aria-label={`Download eBook: ${EBOOK_CTA_TITLE}`}
        onClick={() => trackEbookCtaClick("article_banner")}
        {...getEbookCtaTrackingAttributes()}
    >Download Now</a></p>
  </header> */}

        <div className="container">
            <div className="inner-page-breadcrumb-wrapper mb-20">
                <ul>
                    <li><a href="/">Home</a></li>
                    {blogData?.category && (
                        <li><a href={buildEmagazineCategoryPath(blogData.category)}>{blogData.category}</a></li>
                    )}
                    {blogData?.title && <li>{blogData.title}</li>}
                </ul>
            </div>
            <div className="row g-lg-4 gy-5">
                <div className="col-lg-8">
                <div className="post-thump">
                    <img
                        src={blogData?.banner
                            ? buildEmagazineUploadUrl(blogData.banner)
                            : undefined}
                        alt={blogData?.title ? `${blogData.title} article banner` : "BYB eMagazine article banner"}
                    />
                </div>

                <ul className="post-meta">
                    <li>
                        {blogData?.created_by && <a href={articleAuthorPath || "#"}>{blogData.created_by}</a>}
                    </li>
                    <li>
                        {blogData?.created_at && (
                            <a
                                className="publish-date"
                                href={blogData?.category ? buildEmagazineCategoryPath(blogData.category) : "/e-magazine/"}
                            >
                                {new Date(blogData.created_at).toLocaleDateString("en-US", {
                                    day: "2-digit", month: "short", year: "numeric"
                                })}
                            </a>
                        )}
                    </li>
                </ul>

                <h1>{blogData?.title || (isBlogLoading ? "Loading Blog..." : "Untitled Blog")}</h1>

                <div className="row justify-content-center">
                    <div className="col-lg-10 mb-60">
                        {blogData?.content && (
                            <div className="blog-content" dangerouslySetInnerHTML={{ __html: normalizedBlogContent }} />
                        )}
                        {!blogData?.content && blogError && (
                            <p style={{ color: "red" }}>{blogError}</p>
                        )}
                    </div>
                </div>

                {relatedArticles.length > 0 && (
                    <div className="blog-post-area pt-90 mb-5" aria-labelledby="related-articles-heading">
                        <h6 id="related-articles-heading">Related Articles</h6>
                        <span className="line-break3"></span>
                        <span className="line-break"></span>
                        <div className="row gy-5">
                            {relatedArticles.map((post) => (
                                <div className="col-md-6" key={post.articlePath}>
                                    <div className="blog-card2 two">
                                        <div className="blog-card-img-wrap">
                                            <a href={post.articlePath}>
                                                <img
                                                    src={post.imageUrl || buildEmagazineUploadUrl(post.image2)}
                                                    alt={post.title ? post.title + " related article thumbnail" : "Related BYB eMagazine article thumbnail"}
                                                    loading="lazy"
                                                    decoding="async"
                                                />
                                            </a>
                                            <ul className="px-0">
                                                <li>
                                                    <a className="category text-decoration-none" href={post.categoryPath}>
                                                        {post.category}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="blog-content">
                                            <ul className="blog-meta">
                                                {getArticleAuthorName(post) && (
                                                    <li><a href={buildAuthorPath(getArticleAuthorName(post)) || "#"}>{getArticleAuthorName(post)}</a></li>
                                                )}
                                                {post.created_at && (
                                                    <li>
                                                        <a className="publish-date" href={post.articlePath}>
                                                            {new Date(post.created_at).toLocaleDateString("en-US", {
                                                                day: "2-digit",
                                                                month: "short",
                                                                year: "numeric"
                                                            })}
                                                        </a>
                                                    </li>
                                                )}
                                            </ul>
                                            <h4>
                                                <a href={post.articlePath}>
                                                    {post.title}
                                                </a>
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="blog-tag">
                    <div className="author-name">
                        {blogData?.created_by && (
                            <h6>Posted by <a href={articleAuthorPath || "#"} style={{color:"#fff"}}>{blogData.created_by}</a></h6>
                        )}
                    </div>
                    <div className="tag-items">
                        <h6>Categorized:</h6>
                        {blogData?.tags}
                    </div>
                </div>

                <div className="post-btn">
        {isLoading ? (
            <p>Loading posts...</p>
        ) : error ? (
            <p style={{ color: "red" }}>{error}</p>
        ) : randomPosts.length > 0 ? (
            <>
                {randomPosts[0] && (
                <div className="privious-post-btn">
                    <a href={buildEmagazineArticlePath(randomPosts[0].category, randomPosts[0].slug)}>
                        <svg className="arrow" width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 10L1 1M1 1C3 1.375 7.375 2.125 10 1M1 1C1.375 2.875 2.125 7 1 10" stroke="white" strokeWidth="1.5" strokeLinecap="round"></path>
                        </svg>
                        Previous Post
                    </a>
                </div>
                )}

                {randomPosts[1] && (
                <div className="next-post-btn">
                    <a href={buildEmagazineArticlePath(randomPosts[1].category, randomPosts[1].slug)}>
                        <svg className="arrow" width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 9L9 1M9 1C7.22222 1.33333 3.33333 2 1 1M9 1C8.66667 2.66667 8 6.33333 9 9" stroke="#191919" strokeWidth="1.5" strokeLinecap="round"></path>
                        </svg>
                        Next Post
                    </a>
                </div>
                )}
            </>
        ) : (
            <p>No posts available.</p>
        )}
    </div>


                    <div className="share-post-area">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="share-post-content">
                                    <h3>Share This Post</h3>
                                    <ul>
                                        <li>
                                            <a className="icon" href="https://www.facebook.com/BrewYourBrandOfficial/">
                                                <svg width="6" height="12" viewBox="0 0 6 12"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M3.81526 11.2483V6.46735H5.42818L5.66793 4.59543H3.81526V3.4031C3.81526 2.86293 3.96576 2.4931 4.74101 2.4931H5.72334V0.824182C5.24538 0.77296 4.76495 0.748228 4.28426 0.750099C2.85859 0.750099 1.87976 1.62043 1.87976 3.21818V4.59193H0.277344V6.46385H1.88326V11.2483H3.81526Z" />
                                                </svg>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="icon" href="https://x.com/brew_your_brand">
                                                <svg width="14" height="14" viewBox="0 0 14 14"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <g>
                                                        <path
                                                            d="M11.025 0.65625H13.1722L8.48225 6.0305L14 13.3438H9.68012L6.2965 8.9075L2.42462 13.3438H0.2765L5.29287 7.595L0 0.65625H4.43013L7.48825 4.71012L11.025 0.65625ZM10.2725 12.0557H11.4625L3.78262 1.87687H2.50688L10.2725 12.0557Z" />
                                                    </g>
                                                </svg>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="icon" href="https://www.linkedin.com/company/brew-your-brand">
                                                <svg width="14" height="14" viewBox="0 0 14 14"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M2.90719 4.1972C3.61209 4.1972 4.18353 3.62576 4.18353 2.92086C4.18353 2.21597 3.61209 1.64453 2.90719 1.64453C2.20229 1.64453 1.63086 2.21597 1.63086 2.92086C1.63086 3.62576 2.20229 4.1972 2.90719 4.1972Z">
                                                        </path>
                                                        <path
                                                            d="M5.38752 5.16523V12.2463H7.5861V8.74457C7.5861 7.82057 7.75994 6.92573 8.9056 6.92573C10.0355 6.92573 10.0495 7.98215 10.0495 8.8029V12.2469H12.2493V8.36365C12.2493 6.45615 11.8386 4.99023 9.60911 4.99023C8.53869 4.99023 7.82119 5.57765 7.52777 6.13357H7.49802V5.16523H5.38752ZM1.80469 5.16523H4.00677V12.2463H1.80469V5.16523Z">
                                                        </path>
                                                    </svg>
                                                </a>
                                            </li>
                                            <li>
                                                <a className="icon" href="https://www.instagram.com/brew_your_brand">
                                                    <svg width="14" height="14" viewBox="0 0 14 14"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M12.2191 4.84492C12.2132 4.40312 12.1305 3.96571 11.9747 3.55226C11.8396 3.20351 11.6332 2.88679 11.3687 2.62233C11.1043 2.35786 10.7875 2.15147 10.4388 2.01634C10.0307 1.86313 9.59948 1.78029 9.16362 1.77134C8.60246 1.74626 8.42454 1.73926 7.00004 1.73926C5.57554 1.73926 5.39296 1.73926 4.83587 1.77134C4.40022 1.78036 3.96924 1.8632 3.56129 2.01634C3.21249 2.15138 2.89572 2.35773 2.63124 2.62221C2.36677 2.88669 2.16041 3.20346 2.02537 3.55226C1.87186 3.96008 1.7892 4.39116 1.78096 4.82684C1.75587 5.38859 1.74829 5.56651 1.74829 6.99101C1.74829 8.41551 1.74829 8.59751 1.78096 9.15517C1.78971 9.59151 1.87196 10.022 2.02537 10.4309C2.16064 10.7796 2.36715 11.0963 2.63171 11.3606C2.89628 11.625 3.21308 11.8313 3.56187 11.9663C3.96871 12.1256 4.39976 12.2144 4.83646 12.2288C5.39821 12.2538 5.57612 12.2614 7.00062 12.2614C8.42512 12.2614 8.60771 12.2614 9.16479 12.2288C9.60063 12.2202 10.0318 12.1375 10.44 11.9843C10.7886 11.8491 11.1053 11.6426 11.3697 11.3782C11.6341 11.1137 11.8406 10.7971 11.9759 10.4484C12.1293 10.0401 12.2115 9.60959 12.2203 9.17267C12.2454 8.61151 12.253 8.43359 12.253 7.00851C12.2518 5.58401 12.2518 5.40317 12.2191 4.84492ZM6.99654 9.68484C5.50671 9.68484 4.29979 8.47792 4.29979 6.98809C4.29979 5.49826 5.50671 4.29134 6.99654 4.29134C7.71176 4.29134 8.39769 4.57546 8.90343 5.0812C9.40917 5.58694 9.69329 6.27287 9.69329 6.98809C9.69329 7.70331 9.40917 8.38924 8.90343 8.89498C8.39769 9.40072 7.71176 9.68484 6.99654 9.68484ZM9.80062 4.82042C9.71802 4.8205 9.63622 4.80429 9.55989 4.77271C9.48356 4.74114 9.41421 4.69482 9.3558 4.63641C9.29739 4.57801 9.25108 4.50865 9.2195 4.43233C9.18793 4.356 9.17171 4.27419 9.17179 4.19159C9.17179 4.10905 9.18805 4.02732 9.21964 3.95106C9.25122 3.8748 9.29752 3.80551 9.35589 3.74714C9.41425 3.68878 9.48354 3.64248 9.5598 3.61089C9.63606 3.57931 9.71779 3.56305 9.80033 3.56305C9.88287 3.56305 9.96461 3.57931 10.0409 3.61089C10.1171 3.64248 10.1864 3.68878 10.2448 3.74714C10.3031 3.80551 10.3494 3.8748 10.381 3.95106C10.4126 4.02732 10.4289 4.10905 10.4289 4.19159C10.4289 4.53926 10.1477 4.82042 9.80062 4.82042Z">
                                        </path>
                                        <path
                                            d="M6.99589 8.73983C7.96336 8.73983 8.74764 7.95554 8.74764 6.98808C8.74764 6.02061 7.96336 5.23633 6.99589 5.23633C6.02843 5.23633 5.24414 6.02061 5.24414 6.98808C5.24414 7.95554 6.02843 8.73983 6.99589 8.73983Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                                    </ul>
                                    <div className="input-area" id="inviteCode">
                                        <input id="link-input" value={currentUrl} readOnly />
                                        <button type="button" id="copy-link-icon" onClick={handleCopyLink} aria-label="Copy article link" title={isLinkCopied ? "Copied" : "Copy link"}>
                                        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.97324 10.9956C6.99524 11.0066 7.02724 11.0066 7.02724 11.0066V11.0286C7.06024 11.0286 7.12424 10.9846 7.12424 10.9846L8.29028 9.82042L8.32328 9.78845C8.35314 9.76404 8.37852 9.73462 8.39828 9.70151C8.42028 9.65854 8.43028 9.61457 8.40828 9.5716C8.38828 9.52863 8.35528 9.48566 8.31228 9.48566C7.87035 9.39014 7.46545 9.1691 7.14624 8.84912C6.76572 8.47567 6.53189 7.97821 6.48723 7.44712C6.45456 7.1118 6.49673 6.77341 6.61069 6.45634C6.72464 6.13926 6.90755 5.85138 7.14624 5.61343L10.2003 2.55962C11.0634 1.69624 12.5744 1.69624 13.4384 2.55962C13.8704 3.0023 14.1084 3.57389 14.1084 4.18845C14.1084 4.80301 13.8704 5.3856 13.4384 5.81729L12.0464 7.1983C12.0306 7.21556 12.0193 7.23645 12.0136 7.25912C12.0078 7.28178 12.0077 7.30551 12.0134 7.32821C12.1434 7.79088 12.2184 8.27653 12.2184 8.76218C12.2184 8.99901 12.2084 9.20387 12.1754 9.37674C12.1754 9.4307 12.1974 9.49566 12.2514 9.51664C12.2768 9.532 12.3066 9.53828 12.3361 9.53447C12.3655 9.53066 12.3928 9.51697 12.4134 9.49566L14.7775 7.14434C16.4075 5.50451 16.4075 2.85041 14.7775 1.22158C13.9921 0.43928 12.9283 0 11.8194 0C10.7104 0 9.6467 0.43928 8.86129 1.22158L5.80721 4.27539C5.5372 4.5452 5.32219 4.83699 5.16019 5.12778L5.14719 5.13778C5.13719 5.14577 5.12718 5.15276 5.12718 5.15976C4.79591 5.74751 4.61115 6.40632 4.58852 7.0805C4.56589 7.75467 4.70606 8.42438 4.99718 9.03299C5.20319 9.45269 5.46219 9.83042 5.80721 10.1762C6.14221 10.5209 6.54123 10.8017 6.97324 10.9956ZM1.23107 14.7709C2.0501 15.5803 3.12013 15.99 4.18816 15.99L4.15616 16C5.22419 16 6.30422 15.5903 7.11424 14.7819L10.1683 11.7291C10.727 11.1773 11.1165 10.4777 11.2914 9.7125L11.3564 9.23784C11.3774 9.12992 11.3774 9.02199 11.3774 8.91407V8.48338C11.3774 8.37446 11.3674 8.26654 11.3454 8.1806C11.3354 8.06168 11.3134 7.96475 11.2914 7.86782C11.2664 7.74735 11.234 7.62854 11.1944 7.51208C11.0008 6.87575 10.652 6.29748 10.1793 5.82928C9.84282 5.49624 9.45228 5.22256 9.0243 5.01986C8.9813 4.98788 8.87329 5.04184 8.87329 5.04184L7.70726 6.20601C7.67526 6.23899 7.63226 6.28196 7.59926 6.34591C7.57826 6.37889 7.57826 6.42186 7.59926 6.46582C7.62126 6.50879 7.65326 6.54077 7.69626 6.54077C8.13927 6.62671 8.53828 6.84256 8.86229 7.16632C9.29431 7.60901 9.53231 8.19159 9.52131 8.82713C9.51031 9.21685 9.41331 9.59359 9.2293 9.91635C9.17794 10.0094 9.11658 10.0965 9.0463 10.1762C9.0033 10.2411 8.9493 10.3161 8.86229 10.402L5.80721 13.4548C5.37361 13.8759 4.79279 14.1115 4.18816 14.1115C3.58352 14.1115 3.00271 13.8759 2.56911 13.4548C2.13942 13.0215 1.89858 12.436 1.89909 11.826C1.89909 11.2114 2.1371 10.6288 2.56911 10.1972L3.96215 8.80615C3.99415 8.76318 4.00515 8.70922 3.99415 8.66625C3.77779 8.01315 3.71483 7.31903 3.81015 6.6377C3.81488 6.60938 3.81008 6.58029 3.79651 6.55498C3.78294 6.52966 3.76136 6.50956 3.73515 6.4978C3.69214 6.46483 3.58414 6.51879 3.58414 6.51879L1.23007 8.85911C0.838368 9.24512 0.527785 9.70543 0.316558 10.213C0.105332 10.7206 -0.00228147 11.2653 3.66695e-05 11.815C3.66695e-05 12.9252 0.44305 13.9834 1.23007 14.7699L1.23107 14.7709Z"></path>
                                            </svg>
                                        </button>
                                        <span id="copy-text" className={`copy-text${isLinkCopied ? ' show' : ''}`}></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="subscribe-section">
                         <h3>Subscribe To Get Updates on Latest Blog Posts</h3>

                            <div className="input-area">
                                <input
                                    type="email"
                                    placeholder="Enter Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className=""
                                />
                                <button type="submit" className="subscriber-button" onClick={handleSubscribe}>
                                <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.9647 0.685806C16.0011 0.594942 16.01 0.495402 15.9904 0.399526C15.9707 0.303649 15.9233 0.215653 15.8541 0.146447C15.7849 0.0772403 15.6969 0.0298668 15.601 0.0101994C15.5052 -0.0094681 15.4056 -0.000564594 15.3147 0.0358061L0.76775 5.85481H0.76675L0.31475 6.03481C0.22914 6.06895 0.154635 6.1261 0.0994654 6.19994C0.0442956 6.27377 0.0106078 6.36142 0.00212322 6.4532C-0.00636132 6.54497 0.0106876 6.63731 0.0513867 6.72001C0.0920859 6.8027 0.154851 6.87254 0.23275 6.92181L0.64275 7.18181L0.64375 7.18381L5.63875 10.3618L8.81675 15.3568L8.81875 15.3588L9.07875 15.7688C9.12817 15.8464 9.19805 15.9089 9.28068 15.9493C9.36332 15.9897 9.45551 16.0066 9.54711 15.998C9.63871 15.9894 9.72617 15.9558 9.79985 15.9007C9.87354 15.8456 9.9306 15.7712 9.96475 15.6858L15.9647 0.685806ZM14.1317 2.57581L6.63775 10.0698L6.42275 9.73181C6.38336 9.66978 6.33078 9.6172 6.26875 9.57781L5.93075 9.36281L13.4247 1.86881L14.6027 1.39781L14.1327 2.57581H14.1317Z">
                                    </path>
                                </svg>
                                </button>
                            </div>

                                {message && <p className={`message ${messageType}`}>{message}</p>}

                                <p>
                                <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_786_352)">
                                    <path d="M12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6ZM9.0225 3.7275C8.96893 3.67411 8.90514 3.63208 8.83495 3.60391C8.76476 3.57574 8.68961 3.56202 8.61399 3.56356C8.53838 3.5651 8.46385 3.58187 8.39486 3.61288C8.32588 3.64388 8.26385 3.68848 8.2125 3.744L5.60775 7.06275L4.038 5.49225C3.93137 5.39289 3.79033 5.3388 3.64461 5.34137C3.49888 5.34394 3.35984 5.40297 3.25678 5.50603C3.15372 5.60909 3.09469 5.74813 3.09212 5.89386C3.08955 6.03958 3.14364 6.18062 3.243 6.28725L5.2275 8.2725C5.28096 8.32586 5.34462 8.36791 5.41469 8.39614C5.48475 8.42437 5.55979 8.43819 5.63531 8.43679C5.71083 8.43539 5.7853 8.4188 5.85427 8.38799C5.92324 8.35719 5.9853 8.31281 6.03675 8.2575L9.03075 4.515C9.13282 4.40887 9.18921 4.26696 9.18781 4.11972C9.1864 3.97248 9.12732 3.83166 9.02325 3.7275H9.0225Z"></path>
                                </g>
                                <defs>
                                    <clipPath id="clip0_786_352">
                                        <rect width="12" height="12" fill="white"></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                                    No Credit Card Required
                                </p>
                            </div>

                        <div className="blog-post-area pt-90 mb-5 d-none" aria-hidden="true">
                            <h6>You May Also Like</h6>
                            <span className="line-break3"></span>
                            <span className="line-break"></span>
                            <div className="row gy-5">
                                {isLoading ? (
                                    <p>Loading posts...</p>
                                ) : error ? (
                                    <p style={{ color: "red" }}>{error}</p>
                                ) : randomPosts.length > 0 ? (
                                    randomPosts.map((post) => (
                                        <div className="col-md-6" key={post.id}>
                                            <div className="blog-card2 two">
                                                <div className="blog-card-img-wrap">
                                                    <a href={buildEmagazineArticlePath(post.category, post.slug)}>
                                                        <img
                                                            src={buildEmagazineUploadUrl(post.image2)}
                                                            alt={post.title ? `${post.title} related article thumbnail` : "Related BYB eMagazine article thumbnail"}
                                                        />
                                                    </a>
                                                    <ul className='px-0'>
                                                        <li>
                                                            <a className="category text-decoration-none" href={buildEmagazineCategoryPath(post.category)}>
                                                                {post.category}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="blog-content">
                                                    <ul className="blog-meta">
                                                        <li><a href={buildAuthorPath(getArticleAuthorName(post)) || "#"}>{post.created_by}</a></li>
                                                        <li>
                                                            <a className="publish-date" href={buildEmagazineArticlePath(post.category, post.slug)}>
                                                                {new Date(post.created_at).toLocaleDateString("en-US", {
                                                                    day: "2-digit",
                                                                    month: "short",
                                                                    year: "numeric"
                                                                })}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                    <h4>
                                                        <a href={buildEmagazineArticlePath(post.category, post.slug)}>
                                                            {post.title}
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>No posts available.</p>
                                )}
                            </div>
                        </div>

                </div>
                <div className="col-lg-4 ">
                    <div className="life-style-sidebar">
                        {/* <div className="sidebar-widget driscription">
                            <div className="header-logo pb-15">
                                <a href="index.html"><img alt="image" className="img-fluid dark" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"/></a>
                                <a href="index.html"><img alt="image" className="img-fluid light" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"/></a>
                            </div>
                            <p><span>Welcome!</span> Feel free to mix and match these subcategories based on your interests and the preferences of your target audience. Health &amp; Wellness is a diverse niche.</p>
                            <div className="counter-area">
                                <ul>
                                    <li className="single-counter">
                                        <a href="https://www.facebook.com/">
                                            <div className="icon">
                                                <svg width="6" height="12" viewBox="0 0 6 12" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.81526 11.2482V6.46723H5.42818L5.66793 4.59531H3.81526V3.40298C3.81526 2.86281 3.96576 2.49298 4.74101 2.49298H5.72334V0.82406C5.24538 0.772838 4.76495 0.748106 4.28426 0.749977C2.85859 0.749977 1.87976 1.62031 1.87976 3.21806V4.59181H0.277344V6.46373H1.88326V11.2482H3.81526Z"></path>
                                                </svg>
                                            </div>
                                            <div className="number">
                                                <h5 className="counter">222</h5>
                                                <span>K</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li className="single-counter">
                                        <a href="https://youtube.com/">
                                            <div className="icon">
                                                <svg width="14" height="11" viewBox="0 0 14 11" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.04462 0.749146H7.1225C7.84175 0.751771 11.4861 0.778021 12.4688 1.04227C12.7658 1.12292 13.0365 1.28012 13.2538 1.49815C13.471 1.71619 13.6273 1.98743 13.7069 2.28477C13.7952 2.61727 13.8574 3.0574 13.8994 3.51152L13.9081 3.60252L13.9274 3.83002L13.9344 3.92102C13.9913 4.72077 13.9983 5.46977 13.9991 5.6334V5.69902C13.9983 5.86877 13.9904 6.66852 13.9274 7.50152L13.9204 7.5934L13.9125 7.6844C13.8687 8.1849 13.804 8.6819 13.7069 9.04765C13.6273 9.34499 13.471 9.61623 13.2538 9.83426C13.0365 10.0523 12.7658 10.2095 12.4688 10.2901C11.4537 10.5631 7.59587 10.5824 7.06125 10.5833H6.937C6.66663 10.5833 5.54838 10.578 4.37587 10.5378L4.22712 10.5325L4.151 10.529L4.00138 10.5229L3.85175 10.5168C2.8805 10.4739 1.95563 10.4048 1.5295 10.2893C1.23255 10.2087 0.961931 10.0516 0.74467 9.83376C0.527409 9.61588 0.371108 9.34482 0.291375 9.04765C0.19425 8.68277 0.1295 8.1849 0.08575 7.6844L0.07875 7.59252L0.07175 7.50152C0.028318 6.90863 0.0043884 6.31448 0 5.72002L0 5.6124C0.00175 5.42427 0.00875 4.77415 0.056 4.05665L0.062125 3.96652L0.06475 3.92102L0.07175 3.83002L0.091 3.60252L0.09975 3.51152C0.14175 3.0574 0.203875 2.6164 0.29225 2.28477C0.371849 1.98743 0.528091 1.71619 0.74536 1.49815C0.96263 1.28012 1.23332 1.12292 1.53038 1.04227C1.9565 0.928521 2.88137 0.85852 3.85262 0.81477L4.00138 0.808645L4.15188 0.803396L4.22712 0.800771L4.37675 0.794646C5.2095 0.767874 6.04258 0.752997 6.87575 0.750021L7.04462 0.749146ZM5.6 3.5579V7.77365L9.23738 5.66665L5.6 3.5579Z"></path>
                                                </svg>
                                            </div>
                                            <div className="number">
                                                <h5 className="counter">222</h5>
                                                <span>K</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li className="single-counter">
                                        <a href="https://www.instagram.com/">
                                            <div className="icon">
                                                <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.2189 3.84492C11.213 3.40312 11.1303 2.96571 10.9745 2.55226C10.8393 2.20351 10.6329 1.88679 10.3685 1.62233C10.104 1.35786 9.78729 1.15147 9.43855 1.01634C9.03041 0.863133 8.59923 0.78029 8.16338 0.771341C7.60221 0.746258 7.4243 0.739258 5.9998 0.739258C4.5753 0.739258 4.39271 0.739258 3.83563 0.771341C3.39997 0.780356 2.969 0.863198 2.56105 1.01634C2.21225 1.15138 1.89548 1.35773 1.631 1.62221C1.36652 1.88669 1.16017 2.20346 1.02513 2.55226C0.871615 2.96008 0.788952 3.39116 0.780714 3.82684C0.75563 4.38859 0.748047 4.56651 0.748047 5.99101C0.748047 7.41551 0.748047 7.59751 0.780714 8.15517C0.789464 8.59151 0.871713 9.02201 1.02513 9.43092C1.16039 9.77962 1.3669 10.0963 1.63147 10.3606C1.89603 10.625 2.21283 10.8313 2.56163 10.9663C2.96847 11.1256 3.39951 11.2144 3.83621 11.2288C4.39796 11.2538 4.57588 11.2614 6.00038 11.2614C7.42488 11.2614 7.60746 11.2614 8.16455 11.2288C8.60039 11.2202 9.03159 11.1375 9.43971 10.9843C9.78837 10.8491 10.105 10.6426 10.3695 10.3782C10.6339 10.1137 10.8403 9.79708 10.9756 9.44842C11.129 9.04009 11.2113 8.60959 11.22 8.17267C11.2451 7.61151 11.2527 7.43359 11.2527 6.00851C11.2515 4.58401 11.2515 4.40317 11.2189 3.84492V3.84492ZM5.9963 8.68484C4.50646 8.68484 3.29955 7.47792 3.29955 5.98809C3.29955 4.49826 4.50646 3.29134 5.9963 3.29134C6.71152 3.29134 7.39745 3.57546 7.90319 4.0812C8.40893 4.58694 8.69305 5.27287 8.69305 5.98809C8.69305 6.70331 8.40893 7.38924 7.90319 7.89498C7.39745 8.40072 6.71152 8.68484 5.9963 8.68484V8.68484ZM8.80038 3.82042C8.71778 3.8205 8.63597 3.80429 8.55965 3.77271C8.48332 3.74114 8.41397 3.69482 8.35556 3.63641C8.29715 3.57801 8.25083 3.50865 8.21926 3.43233C8.18768 3.356 8.17147 3.27419 8.17155 3.19159C8.17155 3.10905 8.1878 3.02732 8.21939 2.95106C8.25098 2.8748 8.29728 2.80551 8.35564 2.74714C8.41401 2.68878 8.4833 2.64248 8.55956 2.61089C8.63581 2.57931 8.71755 2.56305 8.80009 2.56305C8.88263 2.56305 8.96436 2.57931 9.04062 2.61089C9.11688 2.64248 9.18617 2.68878 9.24453 2.74714C9.3029 2.80551 9.3492 2.8748 9.38079 2.95106C9.41237 3.02732 9.42863 3.10905 9.42863 3.19159C9.42863 3.53926 9.14746 3.82042 8.80038 3.82042Z"></path>
                                                    <path d="M5.99589 7.73983C6.96336 7.73983 7.74764 6.95554 7.74764 5.98808C7.74764 5.02061 6.96336 4.23633 5.99589 4.23633C5.02843 4.23633 4.24414 5.02061 4.24414 5.98808C4.24414 6.95554 5.02843 7.73983 5.99589 7.73983Z"></path>
                                                </svg>
                                            </div>
                                            <div className="number">
                                                <h5 className="counter">222</h5>
                                                <span>K</span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div> */}
                        <div className="sidebar-widget featured-post">
                            <h6>Featured Post</h6>

                            {isFeaturedLoading && <p>Loading posts...</p>}
                            {featuredError && <p style={{ color: 'red' }}>{featuredError}</p>}

                            {posts.length > 0 ? (
                                posts.map(post => (
                                    <div className="recent-post mb-20" key={post.id}>
                                        <div className="recent-post-img">
                                            <a href={buildEmagazineArticlePath(post.category, post.slug)}  className='text-decoration-none text-white'>
                                                <img
                                                    src={buildEmagazineUploadUrl(post.image3)}
                                                    alt={post.title ? `${post.title} featured article thumbnail` : "Featured BYB eMagazine article thumbnail"}
                                                />
                                            </a>
                                        </div>
                                        <div className="recent-post-content">
                                            <a href={buildEmagazineArticlePath(post.category, post.slug)} className='text-decoration-none text-white'>
                                                {new Date(post.created_at).toLocaleDateString("en-US", {
                                                    day: "2-digit", month: "short", year: "numeric"
                                                })}
                                            </a>
                                            <h5>
                                                <a href={buildEmagazineArticlePath(post.category, post.slug)}  className='text-decoration-none text-white'>{post.title}</a>
                                            </h5>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                !isFeaturedLoading && <p>No featured posts found.</p>
                            )}
                        </div>

                        {/* <div className="sidebar-widget about-section mb-40">
                            <ul className="category">
                                <li>
                                    <a href="https://brewyourbrand.in/brandselfauditkit">About Us</a>
                                </li>
                                <li>
                                    <a href="/e-magazine/terms-and-conditions/">Terms & Conditions</a>
                                </li>
                                <li>
                                    <a href="#">Support</a>
                                </li>
                                <li>
                                    <a href="/e-magazine/privacy-policy/">Privacy Policy</a>
                                </li>
                            </ul>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    </div>


 <BybFooter/>

</div>
        </>
    );
};



export default BlogDetailPage;
